import moment from 'moment'

const toTable = (user) => {
  return {
    info: {
      id: user.id,
      name: user.name ? user.name : '',
      email: user.email,
      is_owner: user.is_owner
    },
    status: user.is_confirmed ? 'confirmed' : 'pending',
    memberships: user.memberships.length.toString(),
    joined: moment(user.created_at).unix()
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js